// 平台首页
<template>
  <div>	
	<el-row type="flex" justify="center">
		<el-row type="flex" justify="center" style="margin-top:-1.3%;">
			<el-col :span="24">
				<el-row><el-image :src="banner"></el-image></el-row>
			</el-col>
		</el-row>
	</el-row>
	
	<el-row type="flex" justify="center" style="padding:0 0rem;position:relative;z-index: 101;margin-top:-13.5%;height:0;">
	  <el-col>
		  <ul class="oper_ul">
			  <template v-if="!loginFlag">
				  <li><el-image :src="try_1" @click="navToLogin" style="cursor:pointer;"></el-image></li>
			  </template>
			  <template v-else>
				  <li><el-image :src="try_1" @click="toUserCenter" style="cursor:pointer;"></el-image></li>
			  </template>
		  </ul>
	  </el-col>
	</el-row>
	
	<el-row type="flex" justify="center" style="padding:0 0rem;padding-top: 15%;">
	  <el-col :span="24">
		  <el-image :src="ad_1"></el-image>
	  </el-col>
	</el-row>
	<el-row type="flex" justify="center" style="padding:0 0rem;padding-top: 5%;">
	  <el-col :span="24">
		  <el-image :src="ad_2"></el-image>
	  </el-col>
	</el-row>
	<el-row type="flex" justify="center" style="padding:0 0rem;">
	  <el-col :span="24">
		  <el-image :src="ad_3"></el-image>
		  <template v-if="!loginFlag">
				<div style="position: relative;height:0;"><el-image :src="try_2" style="top:-11.875rem;cursor:pointer;" @click="navToLogin"></el-image></div>
		  </template>
		  <template v-else>
		  		<div style="position: relative;height:0;"><el-image :src="try_2" style="top:-11.875rem;cursor:pointer;" @click="toUserCenter"></el-image></div>
		  </template>
	  </el-col>
	</el-row>
	
  </div>
</template>



<style>
  @import "../../assets/css/common.css";
  
</style>
<style scoped>
	ul.oper_ul{margin:0;padding:0;}
	ul.oper_ul li{list-style-type: none;}
</style>

<script>
	import {mapState} from "vuex"
	import connect from '@/util/connect.js'
	export default {
		data() {
			return {
				banner:require("../../assets/audit/banner.png"),
				try_1:require("../../assets/audit/try_1.png"),
				ad_1:require("../../assets/audit/ad_1.png"),
				ad_2:require("../../assets/audit/ad_2.png"),
				ad_3:require("../../assets/audit/ad_3.png"),
				try_2:require("../../assets/audit/try_2.png"),
			}
		},
		computed: {
		  ...mapState({
		    userInfo: state => state.user.userInfo,
		    loginFlag: state => state.user.loginFlag
		  }),
		},
		components: {
		},
		methods: {
			navToLogin(){
				this.$router.push({name: 'login',params:{flag:'1'}})
			},
			// 跳转到企业中心
			toUserCenter() {
			  window.open("https://admin.kefubang.com", '_blank')
			}
		}
	}
</script>